import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Card from '../card/card';
import Column from '../column/column';
import NewsletterSignup from '../newsletter-signup/newsletter-signup';
import Social from '../social/social';

export default class Row extends Component {
  constructor() {
    super();

    this.processStories = this.processStories.bind(this);
  }

  shouldComponentUpdate() {
    if (get(this, 'props.social')) {
      return true;
    }
    return false;
  }

  buildSlugName(currentSite, tag) {
    const tagName = get(tag, '[0].name');
    if (tagName) {
      return tagName;
    }

    return currentSite === 'fastcompany' ? 'News' : 'Latest';
  }

  buildSlugLink(currentSite, tag) {
    const tagData = get(tag, '[0]');
    if (tagData) {
      const tagSlug = get(tagData, 'slug');
      const tagName = get(tagData, 'name');
      if (tagData.taxonomy === 'category') {
        return `/${tagSlug}`;
      }

      if (tagData.taxonomy === 'post_tag') {
        return `/section/${tagSlug}`;
      }
      return tagName;
    }

    return currentSite === 'fastcompany' ? '//news.fastcompany.com/' : null;
  }

  processStories(item, i, arr) {
    if (item.stories) {
      const tag = item.tag;
      return (
        <Column
          key="COLUMNKEY"
          stories={item.stories}
          isPromoting={this.props.isPromoting}
          className="news-column"
          slugName={this.buildSlugName(
            get(item, 'stories[0].currentSite'),
            tag
          )}
          slugLink={this.buildSlugLink(
            get(item, 'stories[0].currentSite'),
            tag
          )}
        />
      );
    }
    if (item.newsletter) {
      return (
        <div
          className={`card-wrapper--${arr.length}`}
          key={`card-wrapper--${arr.length}`}
        >
          <NewsletterSignup
            hideCheckBox={true}
            modifier="homepage"
            title={item.title}
            deck={item.deck}
            poster={item.poster}
            newsletters={[{ list: 'fastcompany', default: true }]}
          />
        </div>
      );
    }

    return (
      <Card
        className={item.bigStory ? 'big-card' : ''}
        metadata={item}
        key={item.id}
        rowCardCount={arr.length}
        bigStory={item.bigStory}
      />
    );
  }

  render() {
    if (!this.props || this.props.stories.indexOf(null) !== -1) {
      return null;
    }

    const { stories } = this.props;
    const social = get(this.props, 'social');
    const hasSocial = !isEmpty(social);
    const parentClassName = `row-component${hasSocial
      ? ' row-component--social'
      : ''}`;

    return (
      <div className={parentClassName}>
        {hasSocial ? <Social {...this.props.social} /> : ''}
        {stories.map(this.processStories)}
      </div>
    );
  }
}

Row.defaultProps = {
  isPromoting: false,
  social: {}
};

Row.propTypes = {
  isPromoting: PropTypes.bool,
  stories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  social: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/views/components/row/row.js